import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { ReactComponent as Call } from "../../../Assets/Images/Icon/CallSmallICON.svg";
import { ReactComponent as Mail } from "../../../Assets/Images/Icon/MailSmallICON.svg";
import { Heading } from "../../../Components/atoms/Typography/Heading/Heading";
import { SubHeader4 } from "../../../Components/atoms/Typography/SubHeader/SubHeader";
import { Text9 } from "../../../Components/atoms/Typography/Text/Text";
import { FormItemsWrap } from "../../../Components/molecules/Wrap/Wrap";
import { ConfirmMessageBoxType2 } from "../../../Components/templates/MessageBox/ConfirmMessageBox/ConfirmMessageBox";
import { SuperAdmin } from "../../../Constants/AppContants";
import { Theme } from "../../../Style/Theme";

export const ContactSupport = ({ userRoleName }) => {
  const { t, i18n } = useTranslation(["glossary"]);
  const [showCode, setshowCode] = useState(2);
  const urlparams = new URLSearchParams(useLocation().search);
  const location = useLocation();

  var mail =
    userRoleName == SuperAdmin
      ? "support@firstdoctor.org"
      : "support@firstdoctor.org";

  useEffect(() => {
    let lan = location.state.lan;
    i18n.changeLanguage(lan);
  }, [location]);

  return (
    <Stack
      style={{
        padding: "38px",
      }}
    >
      <FormItemsWrap
        gap={"32px"}
        width={"398px"}
        justifyContent={"space-around"}
      >
        <FormItemsWrap>
          <Heading text={t("auth.support.title")} />
          <SubHeader4
            text={
              showCode === 1
                ? t("auth.support.heading")
                : showCode === 2
                ? t("auth.support.reset-link-expired")
                : ""
            }
          />
        </FormItemsWrap>
        <ConfirmMessageBoxType2
          noModal={true}
          buttonspace={3}
          positiveButtonAction={() => {
            window.open(`mailto:${mail}`, `_self`);
          }}
          positiveButton={
            <Text9
              icon={<Mail />}
              text={mail}
              color={Theme.palette.blue.primaryBlue}
            />
          }
          negativeButton={
            <Text9
              icon={<Call />}
              text={"0112 595 939"}
              color={Theme.palette.blue.primaryBlue}
            />
          }
          negativeButtonAction={() => {
            window.open("tel:0112 595 939", "_self");
          }}
        />
      </FormItemsWrap>
    </Stack>
  );
};
